import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerService } from './spinner.service';
import { NgModule } from '@angular/core';
import { MzCardModule, MzSpinnerModule } from 'ng2-materialize';
import { CommonModule } from '@angular/common';

@NgModule({
  imports:         [ CommonModule,
                     MzSpinnerModule,
                     MzCardModule ],
  providers:       [ SpinnerService ],
  declarations:    [ SpinnerComponent ],
  entryComponents: [ SpinnerComponent ]
})
export class SpinnerModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/services/spinner/spinner.module.ts